import { render, staticRenderFns } from "./LdBreadcrumbButton.component.vue?vue&type=template&id=354b5002&scoped=true&"
import script from "./LdBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./LdBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./LdBreadcrumbButton.component.vue?vue&type=style&index=0&id=354b5002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b5002",
  null
  
)

export default component.exports